import { useFormContext } from "react-hook-form";

import FormField from "ds/components/Form/Field";
import Input from "ds/components/Input";
import { stringIsRequired } from "utils/formValidators";

type FormFieldValues = Record<"repository" | "namespace" | "branch", string>;

const FormFieldBlobFolderPrefix = () => {
  const {
    register,
    setValue,
    formState: { errors },
  } = useFormContext<FormFieldValues>();

  return (
    <FormField
      label="Folder prefix"
      helperText="The folder inside the integration that holds this stack's source archives, e.g. platform/networking. No branches — runs always use the current HEAD pointer."
      tooltipInfo="Blob Storage stacks don't use branches. Triggering a run without a specific commit uses the archive that the bucket's HEAD object currently names."
      tooltipWidthMode="maxWidthSm"
      error={errors?.repository?.message}
    >
      {({ ariaInputProps }) => (
        <Input
          placeholder="platform/networking"
          error={!!errors?.repository}
          {...register("repository", {
            validate: stringIsRequired("Folder prefix is required."),
            onChange: () => {
              // Blob Storage has no VCS namespace or branch picker; a single
              // synthetic branch "main" always tracks the HEAD pointer.
              setValue("namespace", "", { shouldDirty: true });
              setValue("branch", "main", { shouldDirty: true });
            },
          })}
          {...ariaInputProps}
        />
      )}
    </FormField>
  );
};

export default FormFieldBlobFolderPrefix;
